import React from 'react'
import { MainContext } from './State'
import { withRouter } from 'react-router-dom'
import { Grid, Button } from 'semantic-ui-react'

const Submit = () => {
  return (
    <MainContext.Consumer>
      {({ onSubmit }) => (
        <Grid.Row
          style={{
            marginTop: 10
          }}
        >
          <Button circular color="grey" size="massive" onClick={onSubmit}>
            Submit
          </Button>
        </Grid.Row>
      )}
    </MainContext.Consumer>
  )
}

export default withRouter(Submit)



// WEBPACK FOOTER //
// ./src/components/Controller/Submit.jsx